/* RuffScruffStuff: "Clear cart" button for the cart drawer and cart page */
(function () {
  var LABEL = 'Clear cart';
  var CONFIRM = 'Remove everything from your cart?';

  function makeButton() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ruff-clear-cart';
    btn.setAttribute('data-ruff-clear-cart', '');
    btn.textContent = LABEL;
    return btn;
  }

  function inject() {
    // Cart drawer: put the button at the top of the drawer footer
    document.querySelectorAll('cart-drawer .drawer__footer').forEach(function (footer) {
      if (!footer.querySelector('[data-ruff-clear-cart]')) footer.insertBefore(makeButton(), footer.firstChild);
    });
    // Cart page: put the button under the "Your cart" title row
    document.querySelectorAll('cart-items .title-wrapper-with-link').forEach(function (row) {
      if (!row.parentNode.querySelector('[data-ruff-clear-cart]')) {
        var wrap = document.createElement('div');
        wrap.className = 'ruff-clear-cart-row';
        wrap.appendChild(makeButton());
        row.parentNode.insertBefore(wrap, row.nextSibling);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ruff-clear-cart]');
    if (!btn) return;
    if (!window.confirm(CONFIRM)) return;
    btn.disabled = true;
    btn.textContent = 'Clearing…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () { window.location.reload(); })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = LABEL;
        window.alert('Sorry, the cart could not be cleared. Please try again.');
      });
  });

  function start() {
    inject();
    // The theme redraws the cart after every change, so add the button back when that happens
    var observer = new MutationObserver(function () { inject(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
